
import { $wgsl } from "../../wgsl-preprocessor/wgsl-preprocessor";
import pack_depth from "../chunks/pack_depth.wgsl";
import heatmap from "../chunks/heatmap.wgsl";
import theming_and_highlighting from "../chunks/theming_and_highlighting.wgsl";
import wide_lines from "../chunks/wide_lines.wgsl";
import { getObjectUniformsDeclaration } from "./uniforms/ObjectUniforms";
import { getMaterialUniformsDeclaration } from "./MaterialUniforms";
import basicShader from "./basic.wgsl";
import { getModelMatrixHook } from "./modelMatrixHook";
import { FrameBindGroup } from "./FrameBindGroup";
import { getVertexTransformChunk } from "../chunks/vertex_transform";
import pointDataUniforms from "./point_data_uniforms.wgsl";

/**
 * Returns the WGSL declaration for the point data bind group.
 * @param {number} bindGroup
 * @returns {string}
 */
export function getPointDataDeclaration(bindGroup) {
  return $wgsl(pointDataUniforms, { bindGroup });
}

export function getBasicShader(hasVertexColors, hasWideLines, hasInstanceIdMap, categoryHighlightingEnabled = false, categoryHighlightingFallback = false, hasUV = false, hasTextures = false, useUnorm16 = false, isPoints = false, pointStride = 6, colorOffset = 3, isByteColor = false) {
  // hasCategoryTarget: true when category highlighting uses a dedicated render target (not fallback mode)
  const hasCategoryTarget = categoryHighlightingEnabled && !categoryHighlightingFallback;

  return $wgsl(basicShader, {
    frameBindGroup: FrameBindGroup.getDeclaration(0),
    objectUniforms: getObjectUniformsDeclaration(1, hasInstanceIdMap),
    modelMatrixHook: getModelMatrixHook(),
    materialUniforms: getMaterialUniformsDeclaration(2),
    pointDataUniforms: isPoints ? getPointDataDeclaration(3) : '',
    wide_lines,
    pack_depth,
    heatmap,
    theming_and_highlighting,
    hasVertexColors,
    hasWideLines,
    isPoints,
    hasUV,
    hasTextures,
    categoryHighlighting: categoryHighlightingEnabled,
    categoryHighlightingFallback,
    hasCategoryTarget,
    vertexTransform: getVertexTransformChunk(),
    useUnorm16,
    pointStride: isPoints ? pointStride : 0,
    colorOffset: isPoints ? colorOffset : 0,
    isByteColor: isPoints && isByteColor
  });
}